import type { JSX } from 'react'

import { TopNumber6SC } from './TopNumbers.styled'

export const Top6 = (): JSX.Element => (
  <TopNumber6SC
    width='139'
    height='195'
    viewBox='0 0 139 195'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M75.179 73.3958C87.799 73.3958 98.8865 75.9236 108.442 80.9792C118.177 85.8542 125.659 92.8055 130.887 101.833C136.296 110.681 139 120.882 139 132.438C139 144.715 136.115 155.639 130.346 165.208C124.577 174.597 116.554 181.91 106.278 187.146C96.002 192.382 84.3736 195 71.393 195C48.6771 195 31.0992 186.965 18.6595 170.896C6.21984 154.646 0 131.806 0 102.375C0 81.25 3.15499 63.0139 9.46498 47.6667C15.9553 32.3194 25.1498 20.5833 37.0486 12.4583C49.1278 4.15277 63.2802 0 79.5058 0C88.3398 0 97.0837 1.26389 105.737 3.79167C114.571 6.13888 122.774 9.65971 130.346 14.3542V42.25H129.265C121.873 36.8333 113.94 32.6805 105.467 29.7917C97.1738 26.9028 89.1511 25.4583 81.3988 25.4583C66.7957 25.4583 55.2575 30.875 46.7841 41.7083C38.3106 52.3611 33.2626 67.7986 31.6401 88.0208C38.1304 82.9653 44.8911 79.2639 51.9222 76.9167C58.9533 74.5694 66.7056 73.3958 75.179 73.3958ZM70.8521 169.542C81.6693 169.542 90.5934 166.111 97.6245 159.25C104.656 152.389 108.171 143.632 108.171 132.979C108.171 122.868 104.926 114.743 98.4358 108.604C91.9455 102.285 83.2017 99.125 72.2043 99.125C59.2237 99.125 45.6122 103.729 31.3697 112.938C32.2711 131.535 36.0571 145.618 42.7276 155.188C49.3982 164.757 58.773 169.542 70.8521 169.542Z'
      fill='url(#paint0_linear_5096_100036)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5096_100036'
        x1='-14.3327'
        y1='3.01302'
        x2='172.796'
        y2='170.581'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#EFEFEF' />
        <stop offset='1' stopColor='#7C7984' stopOpacity='0.2' />
      </linearGradient>
    </defs>
  </TopNumber6SC>
)
